import {ChangeDetectorRef, Component, ElementRef,  ViewChild} from '@angular/core';
import {AbstractControl, FormControl, Validators} from '@angular/forms';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';
import { MatDialogRef } from '@angular/material/dialog';

const dateValid = (c: AbstractControl) => {
  if ( !c || !c.value ) {
    return null
  }

  if ( c.value.length === 2 && c.value.every(_ => _) ) {
    return null
  }

  return { invalidDate: 'Please select month and year' }
}

const dateInPast = (c: AbstractControl) => {
  if ( !c || !c.value ) {
    return null
  }

  if ( c.value.length === 2 && c.value.every(_ => _) ) {

    const currDate = new Date();
    if ( 
      c.value[1]  <  currDate.getFullYear() ||
    ( c.value[1] === currDate.getFullYear() && c.value[0] < (currDate.getMonth() + 1 ) )
 
  ) {

    return { dateInPast: 'Please select a present or future date.' };

  }    

  }

  return null
}
@Component({
  selector: 'app-monthpicker',
  templateUrl: './monthpicker.component.html',
  styleUrls: ['./monthpicker.component.sass']
})
export class MonthpickerComponent {

  @ViewChild('myFormField', {read: ElementRef}) private formField: ElementRef;
  showBar: boolean = false;

  constructor(
    private selfRef: MatDialogRef<MonthpickerComponent>,
  ){

  }

  ngAfterViewInit() {

    this.formField.nativeElement.classList.remove("mat-form-field-disabled");

  }

  date = new FormControl(null, [Validators.required, dateValid, dateInPast] );

  get datePlaceholder(): string {
    const ans = ['MM', '/', 'YYYY'];
    
    if (this.date.value) {

      if (this.date.value[0]) {

        const _v = this.date.value[0] < 10 ? `0${this.date.value[0]}` : this.date.value[0];
        ans[0] = _v;
      }

      if (this.date.value[1]) {
        ans[2] = this.date.value[1];
      }
    }

    return ans.join('');
  }


  chosenYearHandler(d: Date) {


    const m = d['_i'];
    // const m = d.getMonth() + 1;
    this.date.setValue([m.month, undefined]);

    return;

  }

  chosenMonthHandler(d: Date, datepicker: MatDatepicker<Date>) {

    const m = d['_i'];
    // const m = d.getMonth() + 1;
    this.date.setValue([m.month + 1, m.year]);
    datepicker.close();

  }

  getRangeDate(){
    this.selfRef.close({"month": this.date.value[0], "year": this.date.value[1]});
  }
}


/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */